module.exports = __webpack_public_path__ + "assets/img/TrendingNow_cover.bee9369d-ps.jpg";